import { Link } from 'react-router-dom';
import SectionHeader from './SectionHeader';
import { SITE, WHY_MAHAGEETA } from '../config/site';

export default function WhyMahageetaSection() {
  return (
    <section className="section why-section">
      <div className="container">
        <SectionHeader
          creative
          light
          align="center"
          label="Why Mahageeta"
          title="A vendor that ships and runs software"
          description={`${SITE.shortName} is structured as a product company — we build platforms, operate them in production, and partner with teams who need the same rigour.`}
        />
        <div className="why-grid">
          {WHY_MAHAGEETA.map((item, index) => (
            <article key={item.title} className="why-card">
              <span className="why-card__num">{String(index + 1).padStart(2, '0')}</span>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
        <p className="why-section__cta">
          <Link to="/about" className="link-muted">
            Learn about our company →
          </Link>
        </p>
      </div>
    </section>
  );
}
